<template>
  <div class="modal-wrapper">
    <div class="modal-wrap">
      <div class="modal-header">
        <span>{{title}}</span>
        <el-icon :size="16" @click="$emit('cancel')"><Close /></el-icon>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <el-button @click="$emit('cancel')">取消</el-button>
        <el-button type="primary" @click="$emit('submit')">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close } from '@element-plus/icons-vue'

  defineProps({
    title: {
      type: String,
      default: ''
    }
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>